import axios from 'axios'
import config from '../config'

const Member = {
    state: {
        memberList: [],
        memberExcel: [],
        checkMemberExcel: [],
        memberDetail: [],
        couponInfo: [],
        referrer: [],
        vipList: [],
        error: false,
        msg: ''
    },
    mutations: {
        MemberList: (state, memberList) => state.memberList = memberList,
        MemberExcel: (state, memberExcel) => state.memberExcel = memberExcel,
        CheckMemberExcel: (state, checkMemberExcel) => state.checkMemberExcel = checkMemberExcel,
        MemberDetail: (state, memberDetail) => state.memberDetail = memberDetail,
        MemberCoupon: (state, couponinfo) => state.couponinfo = couponinfo,
        MemberReferrer: (state, referrers) => state.referrers = referrers,
        VipList: (state, vipList) => state.vipList = vipList,
        ERROR: (state, error) => state.error = error,
        MSG: (state, msg) => state.msg = msg
    },
    actions: {
        async fetchMemberList({commit}, data){
            await axios({
                 method:'post',
                 url: config.LOAD_MEMBER_LIST,
                 data:  data
               }).then((result) => {
                   commit('MemberList', result.data.members)
              
               }).catch((err) => {
                   console.log(err)
               });
            },
        async fetchMemberDetail({commit}, data){
         await axios({
             method:'post',
             url: config.LOAD_MEMBER_DETAIL,
             data: data
          })
          .then((result) => {
              commit('MemberDetail', result.data.member)
          }).catch((err) => {
              console.log(err);
          });
        
        },
        async fetchMemberCoupon({commit}, data){
         await axios({
             method:'post',
             url: config.LOAD_MEMBER_DETAIL,
             data: data
          })
          .then((result) => {
            
              commit('MemberCoupon', result.data.couponinfo)
             
          }).catch((err) => {
              console.log(err);
          });
        
        },
        async fetchMemberReferrer({commit}, data){
         await axios({
             method:'post',
             url: config.LOAD_MEMBER_DETAIL,
             data: data
          })
          .then((result) => {
            
              commit('MemberReferrer', result.data.referrers)
          }).catch((err) => {
              console.log(err);
          });
        
        },
        async addMember({commit}, data){
           axios({
               method:'post',
               url: config.ADD_MEMBER,
               data: data })
               .then((result) => {
                   commit('ERROR', result.data.error)
                   commit('MSG', result.data.msg)
               }).catch((err) => {
                   console.log(err);
               });
        },
        async updateMember({commit}, data){
            await axios({
                method:'post',
                url: config.MEMBER_UPDATE,
                data: data
            })
            .then((result) => {
                commit('ERROR', result.data.error)
                commit('MSG', result.data.msg)
            }).catch((err) => {
                console.log(err)
            });
        },
        async fetchVipList({commit}, data){
            await axios({
                method:'post',
                url: config.LOAD_VIP_LIST,
                data: data
            })
            .then((result) => {
                commit('VipList', result.data.vips)
            }).catch((err) => {
                console.log(err);
            });
        },
        async fetchMemberExcel({commit}, data){
            await axios({
                 method:'post',
                 url: config.LOAD_MEMBER_EXCEL,
                 data:  data
               }).then((result) => {
                   commit('MemberExcel', result.data.excel)
              
               }).catch((err) => {
                   console.log(err)
               });
            },
        async fetchCheckMemberExcel({commit}, data){
            await axios({
                 method:'post',
                 url: config.CHECK_MEMBER_EXCEL,
                 data:  data
               }).then((result) => {
                   commit('CheckMemberExcel', result.data.page_limit)
              
               }).catch((err) => {
                   console.log(err)
               });
            },

    },
    getters: {
        getMemberList: state =>  state.memberList,
        getMemberExcel: state =>  state.memberExcel,
        getCheckMemberExcel: state =>  state.checkMemberExcel,
        getMemberDetail: state => state.memberDetail,
        getMemberError: state => state.error,
        getMemberMsg: state => state.msg,
        getMemberCoupon: state => state.couponinfo,
        getMemberReferrer: state => state.referrers,
        getVipList: state => state.vipList
    },
}

export default Member;